<template>
    <div>
        <!-- 스케줄예약, 스케줄수정 -->

        <reservation-confirm-modal 
        :is-visible="showModal"
        @close="handleModalClose"
        @onClickBtnForceReserveSelectedCustomer="onClickBtnForceReserveSelectedCustomer"
        @onClickBtnWaitReserveSelectedCustomer="onClickBtnWaitReserveSelectedCustomer"
      />

        <div v-show='isShow' class='view-area'>
            <table class='com-table left'>
                <colgroup>
                    <col style='width: 160px;'>
                    <col style='width: 560px;'>
                </colgroup>
                <tbody>
                <tr>
                    <th>강사명 <span class='imp'>*</span></th>
                    <td>
                        <select-form :disabled='isDisableSelectTeacher'
                                     :select-data='[...selectFormTeacher.data]'
                                     :select-value='[...selectFormTeacher.value]'
                                     :selected-value='selectedTeacher'
                                     class='w200'
                                     @update:set='updateEditFieldReservSelectedTeacher'></select-form>
                    </td>
                </tr>
                <tr>
                    <th>수업일자 <span class='imp'>*</span></th>
                    <td>
                        <single-calendar :id='centerId'
                                         ref='lessonDate'
                                         :start-date='lessonDate'
                                         @update='updateLessonDate'
                        ></single-calendar>
                        <span v-if='!isEmpty(lessonTimeAlertMsg)' class='red-txt'>{{ lessonTimeAlertMsg }}</span>
                        <span v-if='!isModify && isCheckOver && isEmpty(lessonTimeAlertMsg)'
                              class='red-txt'>예약가능한 수업 횟수가 없습니다.</span>
                    </td>
                </tr>
                <tr>
                    <th>수업시작시간 <span class='imp'>*</span></th>
                    <td>
                        <select-form :select-data='selectFormStartTime.data'
                                     :select-value='selectFormStartTime.value'
                                     :selected-value='selectFormStartTime.selectedValue'
                                     class='w200'
                                     @update:set='updateReserveTime'></select-form>
                        <!--
                        <span class="dot">:</span>
                        <select-form :select-data='selectFormStartMin.data'
                                     :select-value="selectFormStartMin.value"
                                     :selected-value="selectFormStartMin.selectedValue"
                                     @update:set="updateReserveMin"
                                     class="w100"></select-form>
                        -->

                        <select-form :disabled='true'
                                     :select-data='selectFormLessonTime.data'
                                     :select-value='selectFormLessonTime.value'
                                     :selected-value='selectFormLessonTime.selectedValue'
                                     class='w100'></select-form>
                    </td>
                </tr>
                <!-- 2021.02.06, notbadlife@eb : 그룹예약의 경우 룸 선택 불가 처리, 요건 확인 필요 -->
                <!-- <tr v-if="false">
                    <th>룸 선택</th>
                    <td class="time-table-wrap">
                        <table class="time-table w340">
                            <colgroup>
                                <col style="width: 140px;">
                                <col style="width: 200px;">
                            </colgroup>
                            <tbody>
                            <tr v-for="(room, index) in rooms" :key="index">
                                <th>
                                    <span class="gray">{{room.useStartTime}} ~ {{room.useEndTime}}</span>
                                </th>
                                <td>
                                    <select-form :select-data="[ ...selectFormRoom.data]"
                                                 :select-value="[ ...selectFormRoom.value]"
                                                 :selected-value="room.centerRoomId"
                                                 @update:set="(val) => { updateEditFieldReservCenterRoom(val, room) }"
                                                 :disabled="step < EDIT_STEP.ROOM_MEMO" class="w170"></select-form>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="btn-box" v-if="false">
                            <button class="com-btn">추가</button>
                            <button class="com-btn red">삭제</button>
                        </div>
                    </td>
                </tr> -->
                </tbody>
            </table>
            <!-- <div class="btn-line" v-if="isModify">
                <button class="com-btn">예약삭제</button>
            </div> -->
            <div class='bottom-btn'>
                <button class='com-btn' @click='onClickBtnCancelReservation'>취소</button>
                <button v-if='!isModify && !isCheckOver' class='com-btn blue'
                        @click='onClickBtnRegistReservation'>등록
                </button>
                <button v-else-if='isModify' class='com-btn blue'
                        @click='onClickBtnModifyReservation'>수정
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';
import { Utils } from '@/assets/js/utils';
import SearchCustomerDlg from '@/components/SearchCustomerDlg';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import ReservationConfirmModal from '../components/ReservationConfirmModal.vue'

export default {
    name: 'GroupLessonReservationDlg',
    mixins: [MixinAllowedMenu],
    components: {
        SearchCustomerDlg,
        ReservationConfirmModal,
    },
    computed: {
        centerId() {
            return this.$store.getters['auth/cId'];
        },
        selectedLesson() {
            return Utils.isEmpty(this.selectFormStartTime.selectedValue) ? '' : this.lessonSchedules[this.selectFormStartTime.selectedValue];
        },
        selectedTime() {
            return Utils.isEmpty(this.selectedLesson) ? '' : Utils.getHourMinutes(this.selectedLesson.cls_less_start_tm);
        },
        isDisableSelectTeacher() {
            return !this.isAllowed('SC', 1);
        },
    },
    watch: {
        initCenterId() {
            this.fetchReservationSetting();
        },
    },
    props: {
        initCenterId: {
            type: [Number, String],
            default: '',
        },
        selectFormTeacher: Object,
        callbackSuccess: Function,
        callbackCancel: Function,
    },
    data() {
        return {
            isShow: false,
            isFixedContract: false,
            staffId: '',
            step: 1,
            isModify: false,
            centerContractId: '', // 수정을 위한 필수값
            centerLessonScheduleId: '',
            centerLessonScheduleMasterId: '',
            lessonTimeAlertMsg: '',
            selectedTeacher: '',
            selectedCustomer: {
                name: '',
                id: '',
            },
            selectedProduct: null,
            lessonDate: '',
            selectFormCustomerProduct: {
                list: [],
                data: [],
                value: [],
                selectedValue: '',
            },
            lessonSchedules: {},
            selectFormStartTime: {
                data: [],
                value: [],
                selectedValue: '',
            },
            selectFormStartHour: {
                data: [],
                value: [],
                selectedValue: '',
            },
            selectFormStartMin: {
                data: [],
                value: [],
                selectedValue: '',
            },
            selectFormLessonTime: {
                data: ['30분', '1시간', '1시간 30분', '2시간', '2시간 30분', '3시간'],
                value: [30, 60, 90, 120, 150, 180],
                selectedValue: 60,
            },
            selectFormRoom: {
                data: ['선택 안함'],
                value: [''],
            },
            // rooms: [],

            //
            memberPop: false,
            reservationSetting: {},

            isCheckOver: false,
            orgScheduleId: '',
            holidays: [],
            showModal: false  // 모달의 표시 여부를 제어하는 상태
        };
    },
    mounted() {
        this.init();
    },
    methods: {
          // 모달 열기
        openModal() {
            this.showModal = true
        },
        // 모달 닫기
        handleModalClose() {
            this.showModal = false
        },
        async setPresetData(preset) {
            for (const key in preset) {
                const val = preset[key];
                switch (key) {
                case 'startHour':
                    this.selectFormStartHour.selectedValue = val;
                    break;
                case 'startMin':
                    this.selectFormStartMin.selectedValue = val;
                    break;
                case 'lessonTime':
                    this.selectFormLessonTime.selectedValue = val;
                    break;
                case 'scheduleId':
                    this.selectFormStartTime.selectedValue = val;
                    break;
                default:
                    this[key] = val;
                    break;
                }
            }

            await this.fetchCustomerProductTicket();

            if (!Utils.isEmpty(this.selectedProduct)) {
                // 이 값이 셋팅되어있으면, 이용권명을 보여주지 않는다. (수업>수업관리>등록에서 사용)
                this.isFixedContract = true;
                this.selectFormLessonTime.selectedValue = this.selectedProduct.centerProduct.lessonTime;
            } else if (!Utils.isEmpty(this.selectedCustomer.id) && !Utils.isEmpty(this.centerLessonScheduleId)) {
                const { data: contractData } = await this.getDailyScheduleCustomerContract(this.selectedCustomer.id, this.centerLessonScheduleId);

                let productIndex = 0;
                for (const product of this.selectFormCustomerProduct.list) {
                    if (product.centerProductId === contractData.centerProductId
                        && product.centerContractId === contractData.centerContractId) {
                        this.selectedProduct = product;
                        this.selectFormCustomerProduct.selectedValue = productIndex;
                        break;
                    }
                    productIndex++;
                }
            }

            if (this.isDisableSelectTeacher) {
              this.updateEditFieldReservSelectedTeacher(this.staffId)
            }

            // if(Utils.isEmpty(preset.rooms) || preset.rooms.length === 0) {
            //     this.generateEditFieldRoomInfo();
            // }
        },
        async init() {
            this.staffId = parseInt(this.$store.getters['auth/staffId']);
            await this.fetchReservationSetting();
            await this.fetchCenterRooms();

            const { selectFormStartHour, selectFormStartMin } = this;

            // 수업시작 시간 : 시
            for (let h = 0; h < 24; h++) {
                const hour = h.toString().padStart(2, '0');
                selectFormStartHour.data.push(hour);
                selectFormStartHour.value.push(hour);
            }
            // 수업시작 시간 : 분
            const timeUnitValue = this.reservationSetting.timeUnitValue;
            if (timeUnitValue < 60) {
                for (let m = 0; m < 60; m += timeUnitValue) {
                    const min = m.toString().padStart(2, '0');
                    selectFormStartMin.data.push(min);
                    selectFormStartMin.value.push(min);
                }
            } else {
                selectFormStartMin.data.push('00');
                selectFormStartMin.value.push('00');
            }
        },
        getLessonScheduleByDay(date) {
            // @스웨거: 상품의 일별 예약가능 스케줄 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/lesson/schedule/product/year-month-day/`, {
                params: {
                    centerProductId: this.selectedProduct.centerProductId,
                    staffId: this.selectedTeacher, // no required
                    yearMonthDay: date,
                },
            });
        },
        async fetchLessonStartTimes() {
            try {
                if (Utils.isEmpty(this.lessonDate)) {
                    return;
                }
                const { data } = await this.getLessonScheduleByDay(this.lessonDate);
                if (data.length === 0) {
                    this.lessonTimeAlertMsg = '선택한 날짜에 예약 가능한 수업이 없습니다.';
                    this.selectFormStartTime.data = [];
                    this.selectFormStartTime.value = [];
                    return;
                }

                this.lessonSchedules = {};
                const obj = {
                    data: [],
                    value: [],
                };

                for (const schedule of data) {
                    const key = schedule.cls_center_less_schd_id;
                    this.lessonSchedules[key] = schedule;

                    obj.value.push(key);
                    obj.data.push(Utils.getHourMinutes(schedule.cls_less_start_tm));
                }

                this.selectFormStartTime.data = [...obj.data];
                this.selectFormStartTime.value = [...obj.value];
            } catch (e) {
                console.log(e);
            }
        },
        async fetchCenterRooms() {
            try {
                const { data } = await this.getCenterRooms();
                const obj = Utils.getSelectFormObjectFromArray('name', 'centerRoomId', data);
                this.selectFormRoom.data = ['선택 안함', ...obj.data];
                this.selectFormRoom.value = ['', ...obj.value];
            } catch (e) {
                console.log(e);
            }
        },
        async fetchReservationSetting() {
            const { data } = await this.getCenterReservSetting();
            this.reservationSetting = data;
        },
        async fetchCustomerProductTicket() {
            if (Utils.isEmpty(this.selectedCustomer.id)) {
                return false;
            }

            try {
                const { data } = await this.getCustomerProductTicket(this.selectedCustomer.id);

                this.selectFormCustomerProduct.data = ['이용권 선택'];
                this.selectFormCustomerProduct.value = [''];
                this.selectFormCustomerProduct.list = [...data];

                /*
                [듀엣] 플라잉요가 (2/8) 2019-11-09 ~ 2020-12-08
                */

                const len = data.length;
                for (let i = 0; i < len; i++) {
                    const d = data[i];
                    if (Utils.isEmpty(d.centerProduct)) {
                        // 데이터 정합성 오류 : 상품 정보 없음
                        continue;
                    } else if (d.lessonJoinCount === d.lessonCount) {
                        // 횟수가 모두 차감된 경우
                        continue;
                    }

                    const typeName = Utils.getTicketTypeName(d.centerProduct.ticketType);
                    const productName = `[${typeName}] ${d.productName} (${d.lessonJoinCount}/${d.lessonCount}) ${d.expireStartDt} ~ ${d.expireEndDt}`;
                    this.selectFormCustomerProduct.data.push(productName);
                    this.selectFormCustomerProduct.value.push(i);
                }
            } catch (e) {
                console.log(e);
            }
        },
        updateEditFieldReservSelectedTeacher(val) {
            this.selectedTeacher = val;
            this.fetchLessonStartTimes();
        },
        onClickBtnOpenSearchCustomer() {
            if (this.isModify) {
                return false;
            }

            this.memberPop = true;
        },
        onClickBtnCancelReservation() {
            if (!Utils.isEmpty(this.callbackCancel)) {
                this.callbackCancel();
            }
            this.resetData();
        },
        async onClickBtnRegistReservation() {
            // 값 체크 및 확인
            if (!this.validateReservationValue()) {
                return;
            }

            if (!confirm('예약을 등록하시겠습니까?')) {
                return;
            }

            // 등록
            const params = this.getParams();
            try {
                const { data } = await this.putGroupLessonReserve(params);
                if (!Utils.isEmpty(this.callbackSuccess)) {
                    this.callbackSuccess(data);
                    this.resetData();
                }
            } catch (e) {
                console.log(e);
                if('CAPACITY_FULL' === e.response.data.message) {
                    this.openModal();
                }else {
                    Utils.alertResponseErrorMessge(e);       
                }
                //
            }
        },
        async onClickBtnWaitReserveSelectedCustomer() {

              // 값 체크 및 확인
              if (!this.validateReservationValue()) {
                return;
            }

         

            // 등록
            const params = this.getParams();

            const params2 = {
                    ...params,
                    forceReservationTypeCd : 'FW'
                };
            try {
                const { data } = await this.putGroupLessonReserve(params2);
                if (!Utils.isEmpty(this.callbackSuccess)) {
                    this.callbackSuccess(data);
                    this.resetData();
                }
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);       
                }
    
        },
        async onClickBtnForceReserveSelectedCustomer() {

            // 값 체크 및 확인
            if (!this.validateReservationValue()) {
            return;
            }

          

            // 등록
            const params = this.getParams();
            const params2 = {
                ...params,
                forceReservationTypeCd : 'FR'
            };
            try {
            const { data } = await this.putGroupLessonReserve(params2);
            if (!Utils.isEmpty(this.callbackSuccess)) {
                this.callbackSuccess(data);
                this.resetData();
            }
            } catch (e) {
            console.log(e);
            Utils.alertResponseErrorMessge(e);       
            }
        },
        async onClickBtnModifyReservation() {
            // 값 체크 및 확인
            if (!this.validateReservationValue()) {
                return;
            }

            if (!confirm('예약을 수정하시겠습니까?')) {
                return;
            }

            // 수정
            const params = this.getParams();
            try {
                const params = {
                    centerLessonScheduleId: this.selectFormStartTime.selectedValue,
                    reservationDevice: 'AW',
                    reservationType: 'S',
                };

                try {
                    const result = await this.updateCenterGroupLessonScheduleReservation(params);
                    this.resetData();
                    this.callbackSuccess();
                } catch (error) {
                    Utils.alertResponseErrorMessge(error);
                    console.log(error);
                    console.log('error');
                }


                // if (this.lessonSchedules.cls_less_type_cd === 'G' || this.lessonSchedules.cls_less_type_cd === 'C') {
                //     console.log("동작");
                // } else {
                //     //const { data } = await this.putLessonScheduleCustomer(params, this.centerLessonScheduleId);

                //     // if( !Utils.isEmpty(data) && !Utils.isEmpty(data.centerLessonScheduleId) ) {
                //     //     if(!Utils.isEmpty(this.callbackSuccess)) {
                //     //         this.callbackSuccess(data);
                //     //         this.resetData();
                //     //     }
                //     // }
                //     // else {
                //     //     alert("오류가 발생하였습니다.");
                //     // }
                // }
            } catch (e) {
                console.log(e);
            }
        },
        onSelectSearchCustomerDlg(customer) {
            this.selectedCustomer = {
                id: customer.centerCustomerId,
                name: customer.name,
            };

            this.memberPop = false;

            this.fetchCustomerProductTicket();
        },
        onCancelSearchCustomerDlg() {
            this.memberPop = false;
        },
        updateLessonDate(date) {
            if (Utils.isEmpty(date)) {
                // resetDate 호출 후, 자식으로부터 재호출 되는 경우를 막는다.
                return;
            }

            this.checkLessonDate(date);
            this.checkLessonCount(date);
        },
        updateReserveTime(startTime) {
            this.selectFormStartTime.selectedValue = startTime;
            this.checkReserveTime();
            // this.updateRoomTime();
        },
        updateEditFieldReservCenterRoom(val, room) {
            room.centerRoomId = val;

            // @TODO: 룸 사용가능 여부 확인
            //
        },
        // updateRoomTime(){
        //     const dtFormat = 'YYYY-MM-DD HH:mm:ss', tmFormat = 'HH:mm';
        //     const { lessonDate, selectFormStartHour, selectFormStartMin, selectFormLessonTime } = this;

        //     let lessonStartTime = moment(`${lessonDate} ${selectFormStartHour.selectedValue}:${selectFormStartMin.selectedValue}:00`, dtFormat);

        //     const len = this.rooms.length;
        //     for(let i = 0; i < len; i++) {
        //         const room = this.rooms[i];
        //         room.useStartTime = lessonStartTime.format(tmFormat);
        //         room.useEndTime = lessonStartTime.add(30, 'minutes').format(tmFormat);
        //     }
        // },
        updateCenterGroupLessonScheduleReservation(params) {
            return api.put(`/admin/api/center/${this.centerId}/lesson/schedule/group/modifyCustomer/${this.selectedCustomer.id}/${this.orgScheduleId}`, {
                ...params,
            });
        },
        setReservCustomerProduct(val) {
            const { selectFormCustomerProduct } = this;
            selectFormCustomerProduct.selectedValue = val;

            const product = selectFormCustomerProduct.list[val];
            this.selectedProduct = product;

            if (Utils.isEmpty(product)) {
                this.step = this.EDIT_STEP.TICKET;
            } else {
                this.selectFormLessonTime.selectedValue = product.centerProduct.lessonTime;
                this.generateEditFieldRoomInfo();
            }

            // 수업일자가 셋팅되어있다면, 날짜 체크
            if (!Utils.isEmpty(this.lessonDate)) {
                this.checkLessonDate(this.lessonDate);
            }
        },
        getCustomerProductTicket(customerId = '') {
            // 스웨거 검색: 회원의 이용권(비 그룹레슨) 목록조회
            return api.get(`/admin/api/center/${this.centerId}/customer/ticketList/notGroup/${customerId}`);
        },
        getCenterReservSetting() {
            // 스웨거 검색: 센터예약시간설정 조회
            return api.get(`/admin/api/center/${this.centerId}/reservation-setting`);
        },
        getCenterRooms() {
            // 스웨거 검색: 센터 룸 조회
            return api.get(`/admin/api/centerRoom/${this.centerId}`);
        },
        getLessonScheduleDuplicateCustomer(scheduleId) {
            // const {
            //     lessonDate, selectFormLessonTime, selectedTime, selectedCustomer,
            // } = this;
            //
            // const centerCustomerId = selectedCustomer.id;
            // const tmFormat = 'HH:mm:ss';
            // const dtFormat = 'YYYY-MM-DD HH:mm:ss';
            // const startTime = `${selectedTime}:00`;
            //
            // const lessonStartDatetime = `${lessonDate} ${startTime}`;
            //
            // const endTime = moment(lessonStartDatetime, dtFormat)
            //     .add(selectFormLessonTime.selectedValue, 'minutes')
            //     .format(tmFormat);
            //
            // const params = {
            //     centerCustomerId,
            //     lessonDate,
            //     startTime,
            //     endTime,
            // };

            // 스웨거 검색: 스케줄 시간 중복 체크
            // return api.get(`/admin/api/center/${this.centerId}/lesson/schedule/duplicate/customer`, { params });

            // 스웨거: 그룹강의 예약내역 조회
            return api.get(`/admin/api/center/${this.centerId}/lesson/schedule/groupLesson/${scheduleId}`);
        },
        putGroupLessonReserve(params) {
            // @스웨거검색: 그룹레슨 예약하기
            return api.put(`/admin/api/center/${this.centerId}/lesson/schedule/groupLessonReserve/customers`, { ...params });
        },
        putLessonScheduleCustomer(params, centerLessonScheduleId = 0) {
            // @스웨거검색: 회원 수업 스케줄 수정하기(개인/OT/듀엣)
            const { selectedCustomer } = this;
            return api.put(`/admin/api/center/${this.centerId}/lesson/schedule/${centerLessonScheduleId}/customer/${selectedCustomer.id}`, { ...params });
        },
        getDailyScheduleCustomerContract(centerCustomerId, centerLessonScheduleId) {
            const params = {
                centerLessonScheduleId,
            };

            return api.get(`/admin/api/center/${this.centerId}/lesson/schedule/daily/customer/${centerCustomerId}/contract`, { params });
        },
        // generateEditFieldRoomInfo(){
        //     const dtFormat = 'YYYY-MM-DD HH:mm:ss', tmFormat = 'HH:mm';
        //     const { lessonDate, selectFormStartHour, selectFormStartMin, selectFormLessonTime } = this;

        //     let lessonStartTime = moment(`${lessonDate} ${selectFormStartHour.selectedValue}:${selectFormStartMin.selectedValue}:00`, dtFormat);

        //     this.rooms = [];

        //     const len = selectFormLessonTime.selectedValue / 30;
        //     for(let i = 0; i < len; i++) {
        //         let useStartTime = lessonStartTime.format(tmFormat);
        //         let useEndTime = lessonStartTime.add(30, 'minutes').format(tmFormat);
        //         this.rooms.push({
        //             centerRoomId : '',
        //             useStartTime,
        //             useEndTime,
        //         })
        //     }
        // },
        getParams() {
            const { selectedLesson } = this;

            return {
                centerId: this.centerId,
                centerLessonScheduleId: selectedLesson.cls_center_less_schd_id,
                attendanceDevice: 'AW',
                reservationType: 'S',
                centerCustomerId: this.selectedCustomer.id,
                centerContractId: this.selectedProduct.centerContractId,
                centerProductId: this.selectedProduct.centerProductId,
                centerCustomerName: this.selectedCustomer.name,
                reservationId: this.staffId,
            };
        },
        async checkLessonScheduleDuplicate() {
            // 전송 조건 확인
            const { lessonDate, selectedTime, selectedCustomer } = this;
            if (Utils.isEmpty(lessonDate)
                || Utils.isEmpty(selectedTime)
                || Utils.isEmpty(selectedCustomer.id)) {
                return false;
            }

            try {
                const { data } = await this.getLessonScheduleDuplicateCustomer(this.selectedLesson.cls_center_less_schd_id);
                const isDuplicated = this.isDuplicate(this.selectedCustomer.id, data.members);
                if (isDuplicated && !this.isModify) {
                    this.lessonTimeAlertMsg = '예약시간이 중복됩니다. 다른 시간을 선택해주세요.';
                }
            } catch (e) {
                console.log(e);
            }
        },
        checkLessonDate(date) {
            const product = this.selectedProduct;

            if (Utils.isEmpty(product) || Utils.isEmpty(product.expireStartDt) || Utils.isEmpty(product.expireEndDt)) {
                this.lessonDate = '';
                this.$refs.lessonDate.resetDate();

                alert('이용권을 선택해주세요.');
                return false;
            }

            const limitDate = this.checkTeacherReservDatetime(date);
            if (!this.isAllowed('LE', 6) && !limitDate.result) {
                this.lessonDate = '';
                this.$refs.lessonDate.resetDate();

                this.lessonTimeAlertMsg = `예약 가능시간이 아닙니다.\n${limitDate.date} 이후 날짜를 선택해주세요.`;
            } else if (!Utils.isDateInRange(date, product.expireStartDt, product.expireEndDt)) {
                this.lessonDate = '';
                this.$refs.lessonDate.resetDate();

                this.lessonTimeAlertMsg = '유효기간 내의 날짜로 선택해주세요.';
            } else {
                if (this.lessonDate !== date) {
                    this.lessonDate = date;
                }
                this.lessonTimeAlertMsg = '';

                this.fetchLessonStartTimes();
            }
        },
        checkTeacherReservDatetime(date, time = '') {
            // 기본값 셋팅
            const now = moment();
            let dFormat = 'YYYY-MM-DD';
            let reservDate = date;

            if (!Utils.isEmpty(time)) {
                reservDate = `${date} ${time}:00`;
                dFormat = `${dFormat} HH:mm:ss`;
            }

            // 오늘 이후 이면
            if (moment(reservDate, dFormat).isSame(now) || moment(reservDate, dFormat).isAfter(now)) {
                return { result: true };
            }

            // 예약 가능 설정
            const { ticketType } = this.selectedProduct.centerProduct;
            let dtStr = '';
            switch (ticketType) {
            case 'P':
            case 'O':
                dtStr = this.reservationSetting.teacherReservationOt;
                break;
            case 'D':
                dtStr = this.reservationSetting.teacherReservationDu;
                break;
            case 'G':
                dtStr = this.reservationSetting.teacherReservationGr;
                break;
            }

            if (Utils.isEmpty(dtStr)) {
                // 설정이 되어있지 않으면
                return { result: true };
            }

            // 날짜 체크. 이전 날짜이면 예약 불가
            // 에약 가능한 최대 날짜 산출
            const [day, hour, min] = dtStr.split('-');

            // 0일 0시 0분으로 세팅되어 있으면 그냥 통과 시킨다.
            if (day == 0 && hour == 0 && min == 0) {
                return { result: true };
            }

            const limitDate = moment().subtract(parseInt(day), 'days');
            if (!Utils.isEmpty(time)) {
                limitDate.subtract(parseInt(hour), 'hours').subtract(parseInt(min), 'minutes');
            }

            // 예약 가능일 이후 부터 현재까지의 범위 안에 예약일시가 있어야 예약 가능
            const result = {
                result: Utils.isDateInRange(reservDate, limitDate.format(dFormat), now.format(dFormat)),
                date: limitDate.format(dFormat),
            };
            return result;
        },
        checkReserveTime() {
            // 강사가 예약 가능한 시간인지 확인하여 알림
            const { lessonDate, selectedTime } = this;

            if (Utils.isEmpty(selectedTime)) {
                // 시간 값이 설정이 되어있지 않는 경우, 체크하지 않는다.
                return { result: true };
            }

            const limitResult = this.checkTeacherReservDatetime(lessonDate, selectedTime);

            if (!this.isAllowed('LE', 6) && !limitResult.result) {
                this.lessonTimeAlertMsg = `예약 가능시간이 아닙니다.\n${limitResult.date} 이후 시간을 선택해주세요.`;
                return;
            }

            this.lessonTimeAlertMsg = '';
            this.checkLessonScheduleDuplicate();
        },
        validateReservationValue() {
            if (Utils.isEmpty(this.selectedTeacher)) {
                alert('강사를 선택해주세요');
                return false;
            } else if (Utils.isEmpty(this.lessonDate)) {
                alert('수업일자를 선택해주세요');
                return false;
            } else if (Utils.isEmpty(this.selectedLesson)) {
                alert('수업시간을 선택해주세요.');
                return false;
            } else if (!Utils.isEmpty(this.lessonTimeAlertMsg)) {
                alert('수업일자/시간을 확인해주세요');
                return false;
            }
            /*
else if(Utils.isEmpty(this.selectedCustomer.name)) {
alert("회원을 선택해주세요");
return false;
}
else if(Utils.isEmpty(this.selectedProduct)) {
alert("이용권을 선택해주세요");
return false;
} */

            return true;
        },
        resetData() {
            this.step = 1;
            this.isModify = false;
            this.lessonTimeAlertMsg = '';
            this.selectedTeacher = '';
            this.selectedCustomer = {
                name: '',
                id: '',
            };

            this.selectedProduct = null;
            this.lessonDate = '';

            this.selectFormCustomerProduct = {
                list: [],
                data: [],
                value: [],
                selectedValue: '',
            };
            this.selectFormStartTime.selectedValue = '';
            this.selectFormLessonTime.selectedValue = 60;
            this.memo = '';
            // this.rooms = [];
            this.lessonSchedules = {};
        },
        show() {
            this.isShow = true;
        },
        hide() {
            this.isShow = false;
        },
        isEmpty(v) {
            return Utils.isEmpty(v);
        },
        async checkLessonCount(lessonDate) {
            const { centerCustomerId, centerContractId, centerProductId } = this.$parent;

            const { data } = await api.get(`/admin/api/center/${this.centerId}/lesson/schedule/check/less/count/over`, {
                params: {
                    centerCustomerId,
                    centerContractId,
                    centerProductId,
                    lessonDate: moment(lessonDate).format('YYYYMMDD'),
                },
            });

            this.isCheckOver = data.result;
        },
        isDuplicate(id, members) {
            let answer = false;
            members.forEach((value) => {
                if (!(value.status === '-' && value.reservationStatus === 'RW')) {
                    if (value.centerCustomerId === id) {
                        answer = true;
                    }
                }
            });
            return answer;
        },
    },
};
</script>

<style scoped>

</style>
